"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _rootMemoryBuffer = _interopRequireDefault(require("../../utils/rootMemoryBuffer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 将当前异常数据与缓存数据对比去重

/*
 * 2、应该针对这段时间内去重
 * 3、如果处理卡顿主线程 那就worker 若不支持worker就不过滤 或者分片过滤
 */
var filter = function filter(next) {
  return function (params) {
    // 将最新的异常数据和之前的数据比较是否重复
    var nowExceptionData = params.data;

    _rootMemoryBuffer.default.getAll().then(function (all) {
      // Raven._isRepeatData源码里通过this._lastData来做比较是否重复。通过改变this指向完成去重功能
      var thisObj = {
        _lastData: null
      };
      var isRepeat = all.some(function (exceptionData) {
        thisObj._lastData = exceptionData;
        return _ravenJs.default._isRepeatData.call(thisObj, nowExceptionData);
      }); // 如果没有有重复就往下处理了

      if (!isRepeat) next(params);
    });
  };
};

var _default = filter;
exports.default = _default;